import { useEffect, useState } from "react";
import api from "@/lib/api";
import { X } from "@phosphor-icons/react";
import SearchableCombobox from "@/components/SearchableCombobox";

const cname = (c) => c.display_name || c.company_name || `${c.first_name || ""} ${c.last_name || ""}`.trim() || c.id;
let cache = null;

// Mehrere Kontakte auswählen (Chips + Suche)
export default function ContactMultiPicker({ value = [], onChange, testId = "contact-multi" }) {
  const [contacts, setContacts] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    api.get("/contacts", { params: { limit: 1000 } }).then(({ data }) => { cache = data || []; setContacts(cache); });
  }, []);
  const byId = Object.fromEntries(contacts.map((c) => [c.id, c]));
  return (
    <div className="space-y-1.5">
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {value.map((id) => (
            <span key={id} className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 text-xs" data-testid={`${testId}-chip-${id}`}>
              {byId[id] ? cname(byId[id]) : id}
              <button type="button" onClick={() => onChange(value.filter((x) => x !== id))} aria-label="entfernen"><X size={10} /></button>
            </span>
          ))}
        </div>
      )}
      <SearchableCombobox value="" placeholder="Kontakt hinzufügen…" testId={testId}
        onChange={(id) => id && !value.includes(id) && onChange([...value, id])}
        options={contacts.filter((c) => !value.includes(c.id)).map((c) => ({ id: c.id, label: cname(c), keywords: [c.owner_number, c.company_name].filter(Boolean).join(" ") }))} />
    </div>
  );
}
